<template>
  <b-row>
    <b-col>
      <cabecalho-repeticao
        titulo="Adicione as informações da API"
        :mostrar-adicionar="false"
        @apply="adicionarItem"
        @remove="removerItem"
      />
      <b-row>
        <b-col cols="2">
          <b-form-group label="Tipo">
            <validation-provider
              #default="{ errors }"
              :name="`Tipo${itemAcesso}`"
            >
              <b-select
                v-model="valueInner.tipoApi"
                :options="options"
              />
              <small class="text-danger">{{ errors[0] ? 'O campo tipo é obrigatório' : '' }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col cols="5">
          <b-form-group label="Chave">
            <validation-provider
              #default="{ errors }"
              :rules="!valueInner.tipoApi ? '' : 'required'"
              :name="`Chave${itemAcesso}`"
            >
              <b-input
                v-model="valueInner.chave"
                :disabled="!valueInner.tipoApi"
              />
              <small class="text-danger">{{ errors[0] ? 'O campo Chave é obrigatório' : '' }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col cols="5">
          <b-form-group label="Segredo">
            <validation-provider
              #default="{ errors }"
              :rules="!valueInner.tipoApi ? '' : 'required'"
              :name="`Segredo${itemAcesso}`"
            >
              <b-input
                v-model="valueInner.segredo"
                :disabled="!valueInner.tipoApi"
              />
              <small class="text-danger">{{ errors[0] ? 'O campo Segredo é obrigatório' : '' }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'

export default {
  name: 'ConfiguracaoApiRow',
  components: {
    ValidationProvider,
    CabecalhoRepeticao: () => import('@/shared/components/cabecalho-repeticao/CabecalhoRepeticao.vue'),
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    itemAcesso: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      required,
      options: [{ value: 'omie', text: 'Omie' }, { value: 'CnpjJa', text: 'CNPJÁ' }],
      valueInner: {
        tipoApi: null,
        chave: null,
        segredo: null,
      },
    }
  },
  watch: {
    value(val, oldVal) {
      if (val !== oldVal) {
        this.valueInner = val
      }
    },
  },
  created() {
    this.valueInner = this.value
  },
  methods: {
    removerItem() {
      this.$emit('remove', this.valueInner)
    },
    adicionarItem() {
      this.$emit('novo', this.valueInner)
    },
  },
}
</script>
